import { SemiCircle } from "@components/background/semi_circle";
import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import {
  FcBusinessContact,
  FcCalendar,
  FcHighPriority,
  FcList,
  FcMoneyTransfer,
  FcPlus,
  FcTodoList,
} from "react-icons/fc";
import { useNavigate } from "react-router-dom";

export const MenuPage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar, setBottomNavigation } = useThemeStore(
    (state) => state
  );

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Menu",
      image: false,
    });
    setAppBar({
      title: "Menu",
      show: true,
      leading: "back",
    });
    setBottomNavigation("hidden");
  }, [setHeader, setAppBar, setBottomNavigation]);

  return (
    <div className="tw-px-4 tw-pb-20">
      <SemiCircle />
      <div className="tw-px-0 card-body">
        <div className="tw-px-4 tw-mb-2">
          <div className="tw-text-base tw-font-medium tw-text-text-primary md:tw-text-2xl">
            Sekolah
          </div>
        </div>
        <div className="tw-mb-2 menu">
          <div className="card-body-grid">
            <div className="tw-mx-2 tw-pb-2 card-grid">
              <div onClick={() => navigate(linkPage.INFO_BIOGRAPH)}>
                <div className="bg-rotated tw-absolute tw-bg-[#f5e9ff]" />
                <FcBusinessContact className="card-icon tw-text-accent-primary" />
                <div className="card-name">Biodata</div>
              </div>
            </div>

            <div className="tw-mx-2 tw-pb-2 card-grid">
              <div onClick={() => navigate(linkPage.HEALTH_PAGE)}>
                <div className="bg-rotated tw-absolute tw-bg-[#e0f9f2]" />
                <FcPlus className="card-icon tw-text-[#00b894] tw-relative tw-z-10" />
                <div className="card-name">Kesehatan</div>
              </div>
            </div>

            <div className="tw-mx-2 tw-pb-2 card-grid">
              <div onClick={() => navigate(linkPage.ABSENCE_PAGE)}>
                <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
                <FcList className="card-icon" />
                <div className="card-name">Absensi</div>
              </div>
            </div>

            <div className="tw-mx-2 tw-pb-2 card-grid">
              <div onClick={() => navigate("/school/tahfidz")}>
                <div className="bg-rotated tw-absolute tw-bg-[#e0f9f2]" />
                <FcTodoList className="card-icon tw-text-[#00b894]" />
                <div className="card-name">Tahfidz</div>
              </div>
            </div>
          </div>
        </div>

        <div className="tw-px-4 tw-mb-2">
          <div className="tw-text-base tw-font-medium tw-text-text-primary md:tw-text-2xl">
            Info Kewajiban
          </div>
        </div>
        <div className="tw-mb-2 menu">
          <div className="card-body-grid">
            <div className="tw-mx-2 tw-pb-2 card-grid">
              <div
                onClick={() => navigate(linkPage.MONTHLY_BILL_PAGE)}
                className="tw-m-0"
              >
                <div className="bg-rotated tw-absolute tw-bg-[#ffecec]" />
                <FcHighPriority className="card-icon tw-text-[#FF5C5C]" />
                <div className="card-name">Bulanan</div>
              </div>
            </div>

            <div className="tw-mx-2 tw-pb-2 card-grid">
              <div
                onClick={() => navigate(linkPage.NON_MONTHLY_BILL_PAGE)}
                className="tw-m-0"
              >
                <div className="bg-rotated tw-absolute tw-bg-[#ffecec]" />
                <FcHighPriority className="card-icon tw-text-[#FF5C5C]" />
                <div className="card-name">Non Bulanan</div>
              </div>
            </div>

            <div className="tw-mx-2 tw-pb-2 card-grid">
              <div
                onClick={() => navigate(linkPage.CHECKING_ACC_PAGE)}
                className="tw-m-0"
              >
                <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
                <FcList className="card-icon" />
                <div className="card-name">Rekening Koran</div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="tw-px-4 tw-mb-2">
          <div className="tw-text-base tw-font-medium tw-text-text-primary md:tw-text-2xl">
            Pembayaran
          </div>
        </div>
        <div className="tw-mb-2 menu">
          <div className="card-body-grid">
            <div className="tw-mx-2 tw-pb-2 card-grid">
              <div
                onClick={() =>
                  navigate(
                    linkPage.FINANCE_REQUEST_VA.replace(":type", "monthly"),
                    {
                      state: {
                        tagihan: true,
                        tipe: "monthly",
                      },
                    }
                  )
                }
                className="tw-m-0"
              >
                <div className="bg-rotated tw-absolute tw-bg-[#ecf4ff]" />
                <FcMoneyTransfer className="card-icon tw-text-[#4D8EFF]" />
                <div className="card-name">Request VA</div>
              </div>
            </div>

            <div className="tw-mx-2 tw-pb-2 card-grid">
              <div
                onClick={() =>
                  navigate(
                    linkPage.FINANCE_REQUEST_VA.replace(":type", "zis"),
                    {
                      state: {
                        tagihan: false,
                        tipe: "zis",
                      },
                    }
                  )
                }
                className="tw-m-0"
              >
                <div className="bg-rotated tw-absolute tw-bg-[#ecf4ff]" />
                <FcMoneyTransfer className="card-icon tw-text-[#4D8EFF]" />
                <div className="card-name">VA ZIS</div>
              </div>
            </div>

            <div className="tw-mx-2 tw-pb-2 card-grid">
              <div
                onClick={() => navigate("/finance/data-va")}
                className="tw-m-0"
              >
                <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
                <FcList className="card-icon" />
                <div className="card-name">Laporan</div>
              </div>
            </div>
          </div>
        </div> */}

        <div className="tw-px-4 tw-mb-2">
          <div className="tw-text-base tw-font-medium tw-text-text-primary md:tw-text-2xl">
            Perizinan
          </div>
        </div>

        <div className="tw-mb-2 menu">
          <div className="card-body-grid">
            <div className="tw-mx-2 tw-pb-2 card-grid">
              <div
                onClick={() => navigate(linkPage.PERMIT_PAGE)}
                className="tw-m-0"
              >
                <div className="bg-rotated tw-absolute tw-bg-[#ffecec]" />
                <FcCalendar className="card-icon tw-text-[#ff6b6b]" />
                <div className="card-name">Request Izin</div>
              </div>
            </div>

            <div className="tw-mx-2 tw-pb-2 card-grid">
              <div
                onClick={() => navigate(linkPage.PERMIT_DATA_PAGE)}
                className="tw-m-0"
              >
                <div className="bg-rotated tw-absolute tw-bg-[#eee]" />
                <FcList className="card-icon" />
                <div className="card-name">Laporan</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
